import pageDirectory from './pageDirectory.js'
import pageView from './pageView.js'
import sliderHostStore from './sliderHostStore.js'

/*
 * Opens a slide-out.
 *
 * Was an Angular factory (step 27 of #614). Each slide-out is a Vue component rendered by
 * `SliderHost`, which `App.vue` mounts: `openSlider` hands the request to it and returns its
 * promise, the same contract `$aside.open(...).result` had. Step 35b moved the resource-selection
 * slider - the last one still on `$aside` - so the aside branch and `useAside` are gone.
 */
const openSlider = (controller, template, resolveObject) => {
  // A slider is a page in everything but name: booking, incompleteBookings and resourceSelection
  // have no route, so opening one is the only evidence that the directory was used at all.
  const directory = pageDirectory.forTemplate(template)

  if (directory) {
    pageView(directory).catch(() => {})
  }

  return sliderHostStore.open({ template: template, props: resolveObject || {} })
}

export default { openSlider: openSlider }
